import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '@/router/root-route';
import { SharedDocumentRoutePage } from '@/features/candidates/shared-document/SharedDocumentPage';

/**
 * EU-594 (complemento — comentário 23123) — visualização EXTERNA de
 * currículo/laudo compartilhado, aberta pelo link público gerado no modal
 * "Compartilhar" (`{RECRUITER_APP_URL}/compartilhado/{token}`).
 *
 * Rota PÚBLICA: filha DIRETA da rootRoute (fora do `authenticatedRoute`) e
 * sem `requireWorkspace` — o KeycloakGate usa check-sso e não força login,
 * então o destinatário anônimo chega ao router e cai aqui sem sessão. Toda a
 * autorização é o próprio token assinado, validado pelo BFF nas rotas
 * `/public/shared-documents/*`.
 */
export const sharedDocumentRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/compartilhado/$token',
  component: SharedDocumentRoutePage,
});
